import { ReactElement } from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { UrlScanCertificate } from "../../../models/url-analysis-data-structures";
import "./CertificateSummary.scss";

interface CertificateSummaryProps {
  certificate: UrlScanCertificate | null;
}

export default function CertificateSummary({
  certificate,
}: CertificateSummaryProps): ReactElement {
  if (!certificate || !certificate.certificate) {
    return (
      <div className="certificate-summary certificate-summary-none">
        Not served over HTTPS
      </div>
    );
  }

  const cert = certificate.certificate;
  const expiryDate = new Date(cert.not_valid_after);
  const isExpired = expiryDate.getTime() < Date.now();
  const isValid = certificate.valid && !isExpired;

  return (
    <div className="certificate-summary">
      <div className={`certificate-status ${isValid ? "valid" : "invalid"}`}>
        {isValid ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
        <span>
          {isValid
            ? "Valid certificate"
            : certificate.error
              ? `Invalid certificate: ${certificate.error}`
              : isExpired
                ? "Certificate expired"
                : "Invalid certificate"}
        </span>
      </div>
      <div className="certificate-field">
        <span className="certificate-field-label">Subject</span>
        <span className="certificate-field-value">{cert.subject}</span>
      </div>
      <div className="certificate-field">
        <span className="certificate-field-label">Issuer</span>
        <span className="certificate-field-value">{cert.issuer}</span>
      </div>
      <div className="certificate-field">
        <span className="certificate-field-label">
          {isExpired ? "Expired" : "Expires"}
        </span>
        <span
          className={`certificate-field-value ${isExpired ? "expired" : ""}`}
        >
          {expiryDate.toLocaleDateString("en-GB")}
        </span>
      </div>
      {cert.subject_alt_names?.length > 0 && (
        <div className="certificate-field">
          <span className="certificate-field-label">Alt names</span>
          <span className="certificate-field-value">
            {cert.subject_alt_names.join(", ")}
          </span>
        </div>
      )}
    </div>
  );
}
